export default __webpack_public_path__ + "static/media/login-side-background.c6633539.png";